<div class="bgColorWhite body-scroll">
  @if (showData) {
<div class="text-center boldText"><h3>{{pageTitle}}</h3></div>
}
  @if (loading) {
<div class="formLoader"><i class="fa fa-spinner fa-spin gt-refresh"></i></div>
}

  @if (!loading && qualDefsData.length) {
<div class="col-md-12 boldText" style="width:100%;">
    <table class="table nowrap table-bordered table-condensed table-hover table-striped boldText custom-table">
      <thead>
      <tr>
        @for (columnName of columnNames; track $index) {
<th nowrap>{{columnName}}</th>
}
        @for (subfCategoryName of subfCategoryNames; track $index) {
<th nowrap>{{subfCategoryName}}</th>
}
      </tr>
      </thead>
      <tbody>
      @for (qualDefRow of qualDefsData; track $index) {
<tr>
        @for (columnName of columnNames; track $index) {
<td nowrap [ngClass]="(columnName.toUpperCase() === 'USD TOTAL' || columnName.toUpperCase() === 'FC TOTAL') ? 'rightAlign' : ''">
          {{(columnName.toUpperCase() === 'USD TOTAL' || columnName.toUpperCase() === 'FC TOTAL') ? (qualDefRow[columnName] | number) : qualDefRow[columnName]}}
        </td>
}
        @for (subfData of subfCategoriesData; track $index) {
<td nowrap class="rightAlign">{{subfData['AMT'] | number}}</td>
}
      </tr>
}
      </tbody>
    </table>
  </div>
}
</div>
